import styled from 'styled-components';

import { min } from '../../../../utils/breakpoints';

const Container = styled.div`
  margin-top: 50px;

  ${min.sm} {
    margin-top: 80px;
  }
`;

export default Container;
